import styled from 'styled-components';
import { mediaQueries, NUM_GRID_BREAKPOINT_LARGE, viewportSizes } from 'developer-docs-shared-components/utils/mediaQueries';
import { GREAT_WHITE } from 'HubStyleTokens/colors';
import Toc from './Toc';
import { ViewportProvider } from 'developer-docs-shared-components/context/ViewportContext';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledSidebar = styled.div.withConfig({
  displayName: "Sidebar__StyledSidebar",
  componentId: "sc-1dxxsae-0"
})(["", "{margin:24px 0;}", "{position:sticky;top:0;}"], mediaQueries.belowWidth(NUM_GRID_BREAKPOINT_LARGE), mediaQueries.aboveWidth(NUM_GRID_BREAKPOINT_LARGE));
const OverflowWrapper = styled.div.withConfig({
  displayName: "Sidebar__OverflowWrapper",
  componentId: "sc-1dxxsae-1"
})(["", "{padding:8px 8px 8px 24px;", ";min-height:100vh;max-height:100vh;overflow:hidden;overflow-y:auto;position:absolute;top:0;right:0;}"], mediaQueries.aboveWidth(NUM_GRID_BREAKPOINT_LARGE), props => props.hasContent ? `border-left: 1px solid ${GREAT_WHITE};` : '');
export default function Sidebar({
  toc,
  resources
}) {
  const hasContent = !!(toc || resources);
  return /*#__PURE__*/_jsx(StyledSidebar, {
    children: hasContent ? /*#__PURE__*/_jsx(OverflowWrapper, {
      hasContent: hasContent,
      children: /*#__PURE__*/_jsx(ViewportProvider, {
        queries: {
          isMobile: `(max-width: ${NUM_GRID_BREAKPOINT_LARGE - 1}px)`,
          isDesktop: `(min-width: ${NUM_GRID_BREAKPOINT_LARGE}px)`,
          isBelowLaptop: `(min-width: ${viewportSizes.laptop - 1}}px)`
        },
        children: /*#__PURE__*/_jsx(Toc, {
          toc: toc,
          resources: resources
        })
      })
    }) : null
  });
}